import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Layout, Menu } from "antd";
import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import logo from "../../../images/logo.svg";
import LogoIon from "../../../images/icon.svg";
import { adminServices, isAllowedService } from "../../../utils/services";

const { SubMenu } = Menu;

const { Sider } = Layout;
const rootSubmenuKeys = ["sub1"];

class Sidebar extends React.Component<any, any> {
  state = {
    collapsed: false,
    openKeys: [],
  };

  componentDidMount() {
    this.setState({
      openKeys: this.props.location.pathname
        ?.split("/")
        ?.find((item: string) => item === "categories")
        ? ["/categories"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "products")
        ? ["/products"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "global-products")
        ? ["/global-products"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "promotions")
        ? ["/promotions"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "finance")
        ? ["/finance"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "locations")
        ? ["/locations"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "keywords")
        ? ["/keywords"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "notifications")
        ? ["/notifications"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "delivery")
        ? ["/delivery"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "feedback")
        ? ["/feedback"]
        : this.props.location.pathname
            ?.split("/")
            ?.find((item: string) => item === "administration")
        ? ["/administration"]
        : [],
    });
  }

  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onOpenChange = (keys: any[]) => {
    const latestOpenKey = keys.find(
      (key: string) => this.state.openKeys.indexOf(key) === -1
    );
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys: keys });
    } else {
      this.setState({ openKeys: latestOpenKey ? [latestOpenKey] : [] });
    }
  };

  render() {
    const pathname = this.props.location.pathname;
    // const { userRole } = this.props.router

    return (
      <Sider
        width={230}
        collapsible
        onCollapse={this.toggleCollapsed}
        onBreakpoint={this.toggleCollapsed}
      >
        <div className="sidebar-menu">
          <div className="dashboard-logo">
            <Link to="/">
              <img
                src={this.state.collapsed === false ? logo : LogoIon}
                alt="JaChai"
              />
            </Link>
          </div>

          <div className="inner-sidebar-content">
            <Menu
              defaultSelectedKeys={["0"]}
              mode="inline"
              inlineCollapsed={this?.state?.collapsed}
              openKeys={this.state.openKeys}
              onOpenChange={this.onOpenChange}
              theme="dark"
            >
              {adminServices?.map((service, i) => {
                if (service?.sub && service?.sub?.length) {
                  if (
                    service?.sub?.filter((item) => {
                      const excludeIcon = item;
                      return (
                        excludeIcon?.icon &&
                        isAllowedService(`${service.name} ${item.name}`)
                      );
                    })?.length === 1 &&
                    service?.sub?.find((item) => {
                      return item.isParent;
                    })
                  ) {
                    const actualPath = `${service?.path}${service?.sub?.[0]?.path}`;

                    return (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                        className={
                          pathname === actualPath && service?.path
                            ? "active"
                            : ""
                        }
                      >
                        <Link to={actualPath}>{service?.name}</Link>
                      </Menu.Item>
                    );
                  } else {
                    return (
                      service?.sub?.find((item) =>
                        isAllowedService(`${service.name} ${item.name}`)
                      ) && (
                        <SubMenu
                          key={service?.path}
                          icon={<FontAwesomeIcon icon={service?.icon} />}
                          title={service?.name}
                        >
                          {service?.sub?.map((sub) => {
                            const actualPath = `${service?.path}${sub?.path}`;
                            const excludeIcon = sub;
                            return (
                              !actualPath.includes(":") &&
                              excludeIcon?.icon &&
                              isAllowedService(
                                `${service.name} ${sub.name}`
                              ) && (
                                <Menu.Item
                                  key={actualPath}
                                  icon={<FontAwesomeIcon icon={sub?.icon} />}
                                  className={
                                    pathname === actualPath ? "active" : ""
                                  }
                                >
                                  <Link to={actualPath}>{sub?.name}</Link>
                                </Menu.Item>
                              )
                            );
                          })}
                        </SubMenu>
                      )
                    );
                  }
                } else {
                  return (
                    isAllowedService(`${service.name}`) && (
                      <Menu.Item
                        key={service?.path}
                        icon={<FontAwesomeIcon icon={service?.icon} />}
                        className={pathname === service?.path ? "active" : ""}
                      >
                        <Link to={service?.path as any}>{service?.name}</Link>
                      </Menu.Item>
                    )
                  );
                }
              })}
            </Menu>
          </div>
        </div>
      </Sider>
    );
  }
}
const mapStateTopProps = (state: { authReducer: { role: any } }) => {
  return { userRole: state.authReducer.role };
};
export default connect(mapStateTopProps, null)(withRouter(Sidebar as any));
